import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_SERVICE;

export const postContact = async (data) => {
  const url = `https://wapi.musicologystudio.com/contact`;

  try {
    const response = await axios.post(url, data)
    return response.data;
  } catch (err) {
    console.error(err);
  }
};

// Events//
export const fetchEvents = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/events`);
    return response.data.events.map(event => {
      return {...event, image: event.imageUrl}
    })
  } catch (error) {
    console.error('Error fetching events', error);
    throw error
  }
};

// Photos//
export const fetchPhotos = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/photos`);
    return response.data.photos.map(photo => {
      return {...photo, image: photo.imageUrl}
    })
  } catch (error) {
    console.error('Error fetching photos', error);
    throw error
  }
};

// Video //

export const fetchVideos = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/videos`);
    return response.data.videos.map(video => {
      return {...video, url: video.youtubeUrl}
    });
  } catch (error) {
    console.error('Error fetching videos', error);
    throw error
  }
};

// Educationals // 

export const fetchEducationals = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/educational`);
    return response.data.educationals.map(educational => {
      return {...educational, image: educational.imageUrl}
    });
  } catch (error) {
    console.error('Error fetching educational', error);
    throw error
  }
};

// Materials /

export const fetchMaterials = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/materials`);
    return response.data.materials.map(material => {
      return {...material, image: material.imageUrl}
    });
  } catch (error) {
    console.error('Error fetching material', error);
    throw error
  }
};

// Apps // 

export const fetchApps = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/apps`);
    return response.data.apps.map(apps => {
      return {...apps, image: apps.imageUrl, link: apps.url}
    });
  } catch (error) {
    console.error('Error fetching apps', error);
    throw error
  }
};